import React, { useState } from 'react';
import './../../css/table.css';
import axios from 'axios';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import Alert from 'react-bootstrap/Alert';
import { useFormik } from 'formik';
import * as yup from 'yup';
import InputCustom from '../Auth/InputCustom';
import styles from '../Auth/input.module.css';
import TextAreaCustom from '../Auth/TextAreaCustom';

const MySwal = withReactContent(Swal);

const NewCountry = () => {
  const [file, setFile] = useState('');

  const initialValues = {
    country: '',
    english_country: '',
    continent: '',
    english_continent: '',
    description: '',
    stay: '',
    studyVisa: '',
    touristVisa: '',
    InvestmentVisa: '',
    jobVisa: '',
    importantCities: '',
  };
  const validationSchema = yup.object({
    country: yup.string().required('وارد کردن کشور الزامیست'),
    english_country: yup
      .string()
      .required('وارد کردن کشور به انگلیسی الزامیست'),
    continent: yup.string().required('وارد کردن قاره الزامیست'),
    english_continent: yup
      .string()
      .required('وارد کردن قاره به انگلیسی الزامیست'),
    description: yup.string().required('وارد کردن مدارک الزامیست'),
    stay: yup.string().required('وارد کردن اقامت الزامیست'),
    studyVisa: yup.string().required('وارد کردن ویزای تحصیلی الزامیست'),
    touristVisa: yup.string().required('وارد کردن ویزای توریسیتی الزامیست'),
    InvestmentVisa: yup
      .string()
      .required('وارد کردن ویزای سرمایه گذاری الزامیست'),
    jobVisa: yup.string().required('وارد کردن ویزای شغلی الزامیست'),
    importantCities: yup.string().required('وارد کردن شهر های مهم الزامیست'),
  });

  const onSubmit = (state) => {
    if (!file) {
      MySwal.fire({
        title: 'یک عکس با فرمت PNG برای پست انتخاب کنید',
        icon: 'error',
      });
    } else {
      let formData = new FormData();

      formData.append('country', state.country);
      formData.append('english_country', state.english_country);
      formData.append('continent', state.continent);
      formData.append('english_continent', state.english_continent);
      formData.append('description', state.description);
      formData.append('stay', state.stay);
      formData.append('studyVisa', state.studyVisa);
      formData.append('touristVisa', state.touristVisa);
      formData.append('InvestmentVisa', state.InvestmentVisa);
      formData.append('jobVisa', state.jobVisa);
      formData.append('importantCities', state.importantCities);
      formData.append('objectKey', file);

      axios
        .post('https://arianaapp.arianaapply.com/panel/create-country', formData)
        .then((response) => {
          console.log(response);
          MySwal.fire({
            title: 'با موفقیت ثبت شد',
            icon: 'success',
          }).then((result) => {
            if (result.isConfirmed) {
              window.location.reload(false);
            }
          });
        })
        .catch((err) => {
          console.log(err);
          MySwal.fire({
            title: 'دوباره امتحان کنید',
            icon: 'error',
          });
        });
    }
  };

  const formik = useFormik({
    initialValues,
    onSubmit,
    validationSchema,
    validateOnMount: true,
  });

  const imageChangeHandler = (e) => {
    setFile(e.target.files[0]);
  };

  return (
    <div className='index'>
      <form onSubmit={formik.handleSubmit}>
        <Alert variant={`primary`}>فرمت عکس ها حتما باید PNG باشد</Alert>
        <Alert variant={`primary`}>
          قبل از آپلود عکس حتما آن را با استفاده از وبسایت های آنلاین مانند
          tinypng بهینه کنید
        </Alert>
        <InputCustom
          name='country'
          type='text'
          label='کشور...'
          formikHandler={formik.getFieldProps('country')}
          formikErrors={formik.errors.country && formik.touched.country}
          formikErrorsName={formik.errors.country}
        />
        <InputCustom
          name='english_country'
          type='text'
          label='نام انگلیسی کشور...'
          formikHandler={formik.getFieldProps('english_country')}
          formikErrors={
            formik.errors.english_country && formik.touched.english_country
          }
          formikErrorsName={formik.errors.english_country}
        />

        <div className={styles.inputWrap}>
          <label className={styles.label}>قاره...</label>
          <select
            name='continent'
            className={
              formik.errors.continent && formik.touched.continent
                ? styles.inputError
                : styles.input
            }
            {...formik.getFieldProps('continent')}>
            <option value=''>انتخاب کنید...</option>
            <option value='اروپا'>اروپا</option>
            <option value='آسیا'>آسیا</option>
            <option value='آفریقا'>آفریقا</option>
            <option value='استرالیا'>استرالیا</option>
            <option value='آمریکا'>آمریکا</option>
          </select>
          {formik.errors.continent && formik.touched.continent && (
            <p className={styles.errorText}>{formik.errors.continent}</p>
          )}
        </div>

        <div className={styles.inputWrap}>
          <label className={styles.label}> قاره به انگلیسی...</label>
          <select
            name='english_continent'
            className={
              formik.errors.english_continent &&
              formik.touched.english_continent
                ? styles.inputError
                : styles.input
            }
            {...formik.getFieldProps('english_continent')}>
            <option value=''>انتخاب کنید...</option>
            <option value='europe'>europe</option>
            <option value='asia'>asia</option>
            <option value='africa'>africa</option>
            <option value='australia'>australia</option>
            <option value='america'>america</option>
          </select>
          {formik.errors.english_continent &&
            formik.touched.english_continent && (
              <p className={styles.errorText}>
                {formik.errors.english_continent}
              </p>
            )}
        </div>

        <TextAreaCustom
          name='description'
          type='text'
          label='توضیحات..'
          formikHandler={formik.getFieldProps('description')}
          formikErrors={formik.errors.description && formik.touched.description}
          formikErrorsName={formik.errors.description}
        />
        <TextAreaCustom
          name='stay'
          type='text'
          label='اقامت..'
          formikHandler={formik.getFieldProps('stay')}
          formikErrors={formik.errors.stay && formik.touched.stay}
          formikErrorsName={formik.errors.stay}
        />
        <TextAreaCustom
          name='studyVisa'
          type='text'
          label='ویزای تحصیلی..'
          formikHandler={formik.getFieldProps('studyVisa')}
          formikErrors={formik.errors.studyVisa && formik.touched.studyVisa}
          formikErrorsName={formik.errors.studyVisa}
        />
        <TextAreaCustom
          name='touristVisa'
          type='text'
          label='ویزای توریستی..'
          formikHandler={formik.getFieldProps('touristVisa')}
          formikErrors={formik.errors.touristVisa && formik.touched.touristVisa}
          formikErrorsName={formik.errors.touristVisa}
        />
        <TextAreaCustom
          name='InvestmentVisa'
          type='text'
          label='ویزای سرمایه گذاری..'
          formikHandler={formik.getFieldProps('InvestmentVisa')}
          formikErrors={
            formik.errors.InvestmentVisa && formik.touched.InvestmentVisa
          }
          formikErrorsName={formik.errors.InvestmentVisa}
        />
        <TextAreaCustom
          name='jobVisa'
          type='text'
          label='ویزای کاری..'
          formikHandler={formik.getFieldProps('jobVisa')}
          formikErrors={formik.errors.jobVisa && formik.touched.jobVisa}
          formikErrorsName={formik.errors.jobVisa}
        />
        <TextAreaCustom
          name='importantCities'
          type='text'
          label='شهر های مهم..'
          formikHandler={formik.getFieldProps('importantCities')}
          formikErrors={
            formik.errors.importantCities && formik.touched.importantCities
          }
          formikErrorsName={formik.errors.importantCities}
        />
        <div className='inputBox'>
          <label>عکس</label>
          <input type='file' name='file' onChange={imageChangeHandler} />
        </div>

        <div className='inputBox'>
          <button
            type='submit'
            className={!formik.isValid && !file ? 'btn-gray' : 'btn-success'}
            disabled={!formik.isValid && !file}>
            ثبت
          </button>
        </div>
      </form>
    </div>
  );
};
export default NewCountry;
